// Generated from App.tsx for a single page build. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from "../pages/Home/Home";
const __wvcRoutePaths = ["/", "/HomePage"];
function AppRoutes() {
  const location = useLocation();
  return <Routes key={location.pathname}>
            <Route path={__wvcRoutePaths[0]} element={<HomePage />} />
            <Route path={__wvcRoutePaths[1]} element={<HomePage />} />
            
            
            
            
            
            
            
            
            
            
            
            </Routes>;
}
function App() {
  return <>
            <div className="app">
                <AppRoutes />
            </div>
        </>;
}
export default App;
